// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { mediumRecipeComponentId } from './MediumRecipeComponent';
import { invItemId } from './InvItem';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationMediumComponentId = (z.number());
export const fermentationMediumComponent = z.object({
    id: fermentationMediumComponentId,
    fermentation_id: fermentationId,
    recipe_component_id: mediumRecipeComponentId.nullable(),
    inventory_item_id: invItemId,
    amount_g: z.string(),
    amount_unit: z.string(),
    added_at: z.date(),
    added_by: operatorId.nullable(),
    notes: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    component_role: z.string().nullable(),
});
export const fermentationMediumComponentInitializer = z.object({
    id: fermentationMediumComponentId.optional(),
    fermentation_id: fermentationId,
    recipe_component_id: mediumRecipeComponentId.optional().nullable(),
    inventory_item_id: invItemId,
    amount_g: z.string(),
    amount_unit: z.string().optional(),
    added_at: z.date().optional(),
    added_by: operatorId.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    component_role: z.string().optional().nullable(),
});
export const fermentationMediumComponentMutator = z.object({
    id: fermentationMediumComponentId.optional(),
    fermentation_id: fermentationId.optional(),
    recipe_component_id: mediumRecipeComponentId.optional().nullable(),
    inventory_item_id: invItemId.optional(),
    amount_g: z.string().optional(),
    amount_unit: z.string().optional(),
    added_at: z.date().optional(),
    added_by: operatorId.optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    component_role: z.string().optional().nullable(),
});
//# sourceMappingURL=FermentationMediumComponent.js.map